export default {
    private: true,
    slug: 'urban-partnership-bank',
    meta: {
        title: 'Urban Partnership Bank X Foap  - Case study',
        description: 'Urban Partnership Bank teamed up with FOAP to launch a video ad campaign',
        ogImage: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-og.jpg')
    },
    hero: {
        visible: true,
        title: 'Case Study',
        logo: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-logo.png')
    },
    challenge: {
        visible: true,
        title: 'Banking with heart & purpose',
        subtitle: `
            The Chicago-based Urban Partnership Bank (UPB) was founded by a community of financial institutions, 
            non-profits, and stakeholders bound by one overriding commitment: to transform and support disadvantaged 
            communities by democratizing the access to affordable and responsible financial products and services.   
        `,
        video: {
            container: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-fbMock.png'),
            poster: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-challenge-videoPoster.jpg'),
            assets: [{
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-urbanPartnershipBank-2.webm',
                type: 'video/webm'
            }, {
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-urbanPartnershipBank-2.mp4',
                type: 'video/mp4'
            }]
        },
        footer: 'The community development bank joined forces with Foap to reach new hearts and minds by deploying an engaging video ad campaign on Facebook –  and recorded an impressive 6X Return On Ad Spend along the way!',
        float01: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-challenge-float01.jpg'),
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-sideBg.svg'),
        ogImage: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-og.jpg')
    },
    solutionv2: {
        visible: true,
        title: 'Looking to the next generation',
        subtitle: `
            UPB wanted to supplement their aging customer base with new and younger account holders by 
            using a medium and platform that particularly appealed to a younger demographic. 
        `,
        photo0: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-whyus-photo-00.jpg'),
    },
    solutionv22: {
        visible: true,
        title: 'Engaging through authenticity',
        subtitle: `
            UPB had a real message to tell to the forgotten of Chicago: you might be knocked down now but sometimes
            all you need is a little help to get back up. UPB hoped to convince Chicago, particularly the younger members
            of the community, that their sustainable banking products and services might be able to provide that little push. 
            All they needed then was to match that real message with an authentic delivery method that could truly speak to 
            their younger target audience.
            <br /><br />
            With its broad community and targeted ad settings, the Facebook network (including Instagram) had always been UPB’s 
            preferred platform to accurately target both existing and new clients. Video ads shaped up as the best medium to 
            grab the attention of the next generation of clients.  And in Foap, the crowdsourced visual content platform, they 
            found the ideal marketing partner to tell their new and bold digital story.
            <br /><br />
            UPB turned to Foap largely for its scope and diversity – 3 million content creators from all around the world make 
            up their talent pool. The Foap creative team launched a video mission to target not just Chicago-based videographers 
            but creatives living in the suburbs crucial to UPB’s campaign. The result? UPB was given a choice of authentic, localized 
            video ads that spoke directly to their target audience.
            <br /><br />
            UPB then selected a winner and uploaded the video ads to Facebook, safe in the knowledge that their assets had been 
            optimized to match Facebook’s best ad practices.
        `,
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-whyus-sideBg.svg'),
        photo1: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-whyus-photo-01.jpg'),
        photo2: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-whyus-photo-02.jpg'),
        photo3: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-whyus-photo-03.jpg'),
    },
    results: {
        visible: true,
        title: 'Dare to be bold',
        textBlock: `
            Mixed with Facebook’s targeting options and the campaign’s authentic delivery, UPB’s faith in 
            video ads was repaid with unprecedented results. What’s more, they were able to identify Lookalike 
            customers to target next. In less than two weeks, their campaign delivered:  
        `,
        list: [{
            styles: { color: '#4AD2FF' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-graph-lines.svg'),
            title: '6x',
            subtitle: 'ROAS'
        }, {
            styles: { color: '#F5A623' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-rocket.svg'),
            title: '65%',
            subtitle: 'lower CPM than 2018 benchmarks'
        }, {
            styles: { color: '#623CC9' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-connection.svg'),
            title: '100000+',
            subtitle: 'people from target audience reached'
        }],
        photo1: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-results-photo-01.jpg'),
        photo2: require('Theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-results-photo-02.jpg'),
        bgSide: require('Theme/images/videoCaseStudies/videoCaseStudy-results-top.svg')
    },
    checkout: {
        visible: true
    }
};



// WEBPACK FOOTER //
// ./src/containers/global/VideoCaseStudy/data/urbanPartnershipBank.js